module.exports = __webpack_public_path__ + "img/intercom_chat_icon_primary.ca2e1cd6.svg";